import { useEffect, useState } from 'react';

export default function usePageReload() {
  const [isReload, setIsReload] = useState(false);

  useEffect(() => {
    const checkIfPageReloaded = () => {
      const entries = performance.getEntriesByType('navigation');
      if (entries.length > 0) {
        const navigationEntry = entries[0] as PerformanceNavigationTiming;
        if (navigationEntry.type === 'reload') {
          setIsReload(true);
        }
      }
    };

    checkIfPageReloaded(); // Verificar na montagem do hook

    // Adiciona um listener para o evento 'load' para verificar se necessário
    window.addEventListener('load', checkIfPageReloaded);

    return () => {
      window.removeEventListener('load', checkIfPageReloaded);
    };
  }, []);

  return isReload;
}
